import React from "react";
import styles from './Error.module.scss';
import Logo from "../logo/Logo";
import PropTypes from "prop-types";

const Error = ({ message }) => {
  return (
    <div className={styles.container}>
      <Logo />
      <h1 className={styles.title}>{message}</h1>
    </div>
  );
};

Error.propTypes = {
  message: PropTypes.string.isRequired
}

export default Error;